import { FC, memo } from 'react'

import { Info, InfoSet, InfoSetDirection } from 'ui/components/Info'
import { Col, Row } from 'ui/themes/globalStyles'

import { MailingAddressProps } from './MailingAddressProps'

export const MailingAddress: FC<MailingAddressProps> = memo(({ applicationRelationship }) => {
  const { state, street, city, postalCode, country } = applicationRelationship.companyMailingAddress

  return (
    <InfoSet direction={InfoSetDirection.ROW} legend="Mailing Address">
      <Row>
        <Col>
          <Info label="Street">{street}</Info>
        </Col>
        <Col>
          <Info label="City">{city}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="State/Province">{state}</Info>
        </Col>
        <Col>
          <Info label="Country">{country}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="Zip/Postal Code">{postalCode}</Info>
        </Col>
      </Row>
    </InfoSet>
  )
})
